module.exports = __webpack_public_path__ + "img/叶坪中华苏维埃共和国总金库旧址.4cb32b87.png";